<template lang="pug">
	.caps-container
		.caps.desktop
			span(v-for="step of maxScore" :style="`display:inline-block;margin-right:4px;width: ${width}px;height: ${height}px`"
			:class="{'low-opacity': score == 'NP' || score == 'NO' || score == 'FDIC' }")
				<svg :width="width" :height="height" :viewBox="`0 0 24 24`" fill="none" xmlns="http://www.w3.org/2000/svg" alt="" v-if="parsedScore >= step" v-html="capRatingFull">
				</svg>
				<svg :width="width" :height="height" :viewBox="`0 0 24 24`" fill="none" xmlns="http://www.w3.org/2000/svg" alt="" v-if="(Number.isNaN(parsedScore)) || (step > parsedScore && step - parsedScore != 0.5)" v-html="capRatingEmpty">
				</svg>
				<svg :width="width" :height="height" :viewBox="`0 0 24 24`" fill="none" xmlns="http://www.w3.org/2000/svg" alt="" v-if="step - parsedScore == 0.5" v-html="capRatingHalf">
				</svg>
			.text-center(v-if="score == 'NP'") New Plan
			.text-center(v-if="score == 'NO'") Not Open
			.text-center(v-if="score == 'FDIC'") FDIC Insured Option
		.score(v-if="showCount && parsedScore > 0")
			span.strong
				| {{ parsedScore }}
			| &nbsp;/ {{ maxScore }}
</template>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'
	.caps-container
		max-height: 25px
		// @media (max-width: 1010px)
		// 	display-flex()
		// 	align-items: center
		.caps
			.text-center
				font-size: 11px !important
				font-weight: body-font-weight-medium
				position: relative
				top: -19px
				// @media (max-width: 1010px)
				// 	top: -30px
			&.desktop
				display: inline-block
			@media (max-width: 369px)
				width: 100%
			// @media (max-width: 1010px)
			// 	width: 60%
			// 	text-align: center
			// 	span
			// 		position: relative
			// 		top: -3px
			@media (max-width: 369px)
				text-align: right
			// @media (min-width: 370px) and (max-width: 1010px)
			// 	text-align: left
		.score
			display: block
			font-size: body-font-size-md
			line-height: body-font-line-heigth-xs
			color: gray-50
			margin-top: 8px
			.strong
				font-weight: body-font-weight-strong
				color: body-font-color-black
			@media (max-width: 369px)
				display: none
			// @media (max-width: 1010px)
			// 	width: 40%
			// 	text-align: right
			// 	margin-top: 0px
		.low-opacity
			opacity: 0.5
</style>

<script>
export default {
	props: {
		score: {
			type: [Number, String],
			default: 0
		},
		maxScore: {
			type: Number,
			default: 5
		},
		width: {
			type: [Number, String],
			default: 24
		},
		height: {
			type: [Number, String],
			default: 24
		},
		mobileWidth: {
			type: [Number, String],
			default: 17
		},
		mobileHeight: {
			type: [Number, String],
			default: 17
		},
		showCount:{
			type: Boolean,
			default: true
		}
	},
	data() {
		const capRatingFull = `
			<g xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g>
									<g>
										<g>
											<path fill="#1E6BD6" d="M11.417 22.778c-.175 0-.34-.068-.463-.192L.499 12.132c-.255-.256-.255-.672 0-.928L10.954.75c.124-.124.288-.192.463-.192.176 0 .34.068.464.192l10.455 10.454c.255.256.255.672 0 .928L11.88 22.586c-.124.124-.288.192-.464.192" transform="translate(-396 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(56) translate(.5)"/>
											<path fill="#FFF" d="M11.417.25c-.257 0-.499.1-.68.283L.281 10.987c-.376.376-.376.987 0 1.363l10.454 10.454c.182.182.424.282.681.282.258 0 .5-.1.682-.282L22.553 12.35c.182-.182.282-.424.282-.682 0-.257-.1-.499-.282-.681L12.099.533C11.917.35 11.675.25 11.417.25m0 .616c.09 0 .179.034.246.102l10.455 10.454c.136.136.136.356 0 .492L11.663 22.37c-.067.068-.157.102-.246.102s-.178-.034-.246-.102L.717 11.914c-.136-.136-.136-.356 0-.492L11.17.968c.068-.068.157-.102.246-.102" transform="translate(-396 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(56) translate(.5)"/>
											<path stroke="#303030" d="M4.53 19.333v-7.37c0-.137.112-.25.25-.25h7.369" transform="translate(-396 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(56) translate(.5)"/>
											<path fill="#F47810" d="M11.41 13.163c-.794 0-1.445-.65-1.445-1.445 0-.794.65-1.445 1.445-1.445s1.445.65 1.445 1.445-.65 1.445-1.445 1.445" transform="translate(-396 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(56) translate(.5)"/>
											<path fill="#F47810" d="M11.41 12.598c-.483 0-.88-.396-.88-.88 0-.483.397-.88.88-.88.484 0 .88.397.88.88 0 .484-.396.88-.88.88M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977" transform="translate(-396 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(56) translate(.5)"/>
											<path stroke="#F47810" stroke-width=".5" d="M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977z" transform="translate(-396 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(56) translate(.5)"/>
											<path fill="#F47810" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736" transform="translate(-396 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(56) translate(.5)"/>
											<path stroke="#F47810" stroke-width=".5" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736z" transform="translate(-396 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(56) translate(.5)"/>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		`
		const capRatingEmpty = `
			<defs xmlns="http://www.w3.org/2000/svg">
				<path id="8a9mmi8nta" d="M0 0.001H12V24.001H0z"/>
				<path id="l1upzcc62c" d="M0 0H12V24H0z"/>
			</defs>
			<g xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd" opacity=".25">
				<g>
					<g>
						<g>
							<g>
								<g>
									<g>
										<g transform="translate(-452 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(112) translate(12)">
											<mask id="nqb4a88fnb" fill="#fff">
												<use xlink:href="#8a9mmi8nta" xmlns:xlink="http://www.w3.org/1999/xlink"/>
											</mask>
											<g mask="url(#nqb4a88fnb)">
												<g>
													<path fill="#1E6BD6" d="M11.417 22.778c-.175 0-.34-.068-.463-.192L.499 12.132c-.255-.256-.255-.672 0-.928L10.954.75c.124-.124.288-.192.463-.192.176 0 .34.068.464.192l10.455 10.454c.255.256.255.672 0 .928L11.88 22.586c-.124.124-.288.192-.464.192" transform="translate(-11.5)"/>
													<path fill="#FFF" d="M11.417.25c-.257 0-.499.1-.68.283L.281 10.987c-.376.376-.376.987 0 1.363l10.454 10.454c.182.182.424.282.681.282.258 0 .5-.1.682-.282L22.553 12.35c.182-.182.282-.424.282-.682 0-.257-.1-.499-.282-.681L12.099.533C11.917.35 11.675.25 11.417.25m0 .616c.09 0 .179.034.246.102l10.455 10.454c.136.136.136.356 0 .492L11.663 22.37c-.067.068-.157.102-.246.102s-.178-.034-.246-.102L.717 11.914c-.136-.136-.136-.356 0-.492L11.17.968c.068-.068.157-.102.246-.102" transform="translate(-11.5)"/>
													<path stroke="#303030" d="M4.53 19.333v-7.37c0-.137.112-.25.25-.25h7.369" transform="translate(-11.5)"/>
													<path fill="#F47810" d="M11.41 13.163c-.794 0-1.445-.65-1.445-1.445 0-.794.65-1.445 1.445-1.445s1.445.65 1.445 1.445-.65 1.445-1.445 1.445" transform="translate(-11.5)"/>
													<path fill="#F47810" d="M11.41 12.598c-.483 0-.88-.396-.88-.88 0-.483.397-.88.88-.88.484 0 .88.397.88.88 0 .484-.396.88-.88.88M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977" transform="translate(-11.5)"/>
													<path stroke="#F47810" stroke-width=".5" d="M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977z" transform="translate(-11.5)"/>
													<path fill="#F47810" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736" transform="translate(-11.5)"/>
													<path stroke="#F47810" stroke-width=".5" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736z" transform="translate(-11.5)"/>
												</g>
											</g>
										</g>
										<g transform="translate(-452 -1567) translate(0 1034) translate(132 369) translate(208 134) translate(0 30) translate(112)">
											<mask id="x3bx644t7d" fill="#fff">
												<use xlink:href="#l1upzcc62c" xmlns:xlink="http://www.w3.org/1999/xlink"/>
											</mask>
											<g mask="url(#x3bx644t7d)">
												<g>
													<path fill="#1E6BD6" d="M11.417 22.778c-.175 0-.34-.068-.463-.192L.499 12.132c-.255-.256-.255-.672 0-.928L10.954.75c.124-.124.288-.192.463-.192.176 0 .34.068.464.192l10.455 10.454c.255.256.255.672 0 .928L11.88 22.586c-.124.124-.288.192-.464.192" transform="translate(.5)"/>
													<path fill="#FFF" d="M11.417.25c-.257 0-.499.1-.68.283L.281 10.987c-.376.376-.376.987 0 1.363l10.454 10.454c.182.182.424.282.681.282.258 0 .5-.1.682-.282L22.553 12.35c.182-.182.282-.424.282-.682 0-.257-.1-.499-.282-.681L12.099.533C11.917.35 11.675.25 11.417.25m0 .616c.09 0 .179.034.246.102l10.455 10.454c.136.136.136.356 0 .492L11.663 22.37c-.067.068-.157.102-.246.102s-.178-.034-.246-.102L.717 11.914c-.136-.136-.136-.356 0-.492L11.17.968c.068-.068.157-.102.246-.102" transform="translate(.5)"/>
													<path stroke="#303030" d="M4.53 19.333v-7.37c0-.137.112-.25.25-.25h7.369" transform="translate(.5)"/>
													<path fill="#F47810" d="M11.41 13.163c-.794 0-1.445-.65-1.445-1.445 0-.794.65-1.445 1.445-1.445s1.445.65 1.445 1.445-.65 1.445-1.445 1.445" transform="translate(.5)"/>
													<path fill="#F47810" d="M11.41 12.598c-.483 0-.88-.396-.88-.88 0-.483.397-.88.88-.88.484 0 .88.397.88.88 0 .484-.396.88-.88.88M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977" transform="translate(.5)"/>
													<path stroke="#F47810" stroke-width=".5" d="M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977z" transform="translate(.5)"/>
													<path fill="#F47810" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736" transform="translate(.5)"/>
													<path stroke="#F47810" stroke-width=".5" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736z" transform="translate(.5)"/>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		`
		const capRatingHalf = `
			<defs xmlns="http://www.w3.org/2000/svg">
				<path id="be4ku6q7pa" d="M0 0.001H12V24.001H0z"/>
				<path id="09epxav44c" d="M0 0H12V24H0z"/>
			</defs>
			<g xmlns="http://www.w3.org/2000/svg" fill="none" fill-rule="evenodd">
				<g>
					<g>
						<g>
							<g>
								<g>
									<g>
										<g opacity=".25" transform="translate(-424 -3648) translate(0 2924) translate(132 560) translate(208 134) translate(0 30) translate(84) translate(12)">
											<mask id="jkn5cr71nb" fill="#fff">
												<use xlink:href="#be4ku6q7pa" xmlns:xlink="http://www.w3.org/1999/xlink"/>
											</mask>
											<g mask="url(#jkn5cr71nb)">
												<g>
													<path fill="#1E6BD6" d="M11.417 22.778c-.175 0-.34-.068-.463-.192L.499 12.132c-.255-.256-.255-.672 0-.928L10.954.75c.124-.124.288-.192.463-.192.176 0 .34.068.464.192l10.455 10.454c.255.256.255.672 0 .928L11.88 22.586c-.124.124-.288.192-.464.192" transform="translate(-11.5)"/>
													<path fill="#FFF" d="M11.417.25c-.257 0-.499.1-.68.283L.281 10.987c-.376.376-.376.987 0 1.363l10.454 10.454c.182.182.424.282.681.282.258 0 .5-.1.682-.282L22.553 12.35c.182-.182.282-.424.282-.682 0-.257-.1-.499-.282-.681L12.099.533C11.917.35 11.675.25 11.417.25m0 .616c.09 0 .179.034.246.102l10.455 10.454c.136.136.136.356 0 .492L11.663 22.37c-.067.068-.157.102-.246.102s-.178-.034-.246-.102L.717 11.914c-.136-.136-.136-.356 0-.492L11.17.968c.068-.068.157-.102.246-.102" transform="translate(-11.5)"/>
													<path stroke="#303030" d="M4.53 19.333v-7.37c0-.137.112-.25.25-.25h7.369" transform="translate(-11.5)"/>
													<path fill="#F47810" d="M11.41 13.163c-.794 0-1.445-.65-1.445-1.445 0-.794.65-1.445 1.445-1.445s1.445.65 1.445 1.445-.65 1.445-1.445 1.445" transform="translate(-11.5)"/>
													<path fill="#F47810" d="M11.41 12.598c-.483 0-.88-.396-.88-.88 0-.483.397-.88.88-.88.484 0 .88.397.88.88 0 .484-.396.88-.88.88M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977" transform="translate(-11.5)"/>
													<path stroke="#F47810" stroke-width=".5" d="M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977z" transform="translate(-11.5)"/>
													<path fill="#F47810" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736" transform="translate(-11.5)"/>
													<path stroke="#F47810" stroke-width=".5" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736z" transform="translate(-11.5)"/>
												</g>
											</g>
										</g>
										<g transform="translate(-424 -3648) translate(0 2924) translate(132 560) translate(208 134) translate(0 30) translate(84)">
											<mask id="tz6ec81hdd" fill="#fff">
												<use xlink:href="#09epxav44c" xmlns:xlink="http://www.w3.org/1999/xlink"/>
											</mask>
											<g mask="url(#tz6ec81hdd)">
												<g>
													<path fill="#1E6BD6" d="M11.417 22.778c-.175 0-.34-.068-.463-.192L.499 12.132c-.255-.256-.255-.672 0-.928L10.954.75c.124-.124.288-.192.463-.192.176 0 .34.068.464.192l10.455 10.454c.255.256.255.672 0 .928L11.88 22.586c-.124.124-.288.192-.464.192" transform="translate(.5)"/>
													<path fill="#FFF" d="M11.417.25c-.257 0-.499.1-.68.283L.281 10.987c-.376.376-.376.987 0 1.363l10.454 10.454c.182.182.424.282.681.282.258 0 .5-.1.682-.282L22.553 12.35c.182-.182.282-.424.282-.682 0-.257-.1-.499-.282-.681L12.099.533C11.917.35 11.675.25 11.417.25m0 .616c.09 0 .179.034.246.102l10.455 10.454c.136.136.136.356 0 .492L11.663 22.37c-.067.068-.157.102-.246.102s-.178-.034-.246-.102L.717 11.914c-.136-.136-.136-.356 0-.492L11.17.968c.068-.068.157-.102.246-.102" transform="translate(.5)"/>
													<path stroke="#303030" d="M4.53 19.333v-7.37c0-.137.112-.25.25-.25h7.369" transform="translate(.5)"/>
													<path fill="#F47810" d="M11.41 13.163c-.794 0-1.445-.65-1.445-1.445 0-.794.65-1.445 1.445-1.445s1.445.65 1.445 1.445-.65 1.445-1.445 1.445" transform="translate(.5)"/>
													<path fill="#F47810" d="M11.41 12.598c-.483 0-.88-.396-.88-.88 0-.483.397-.88.88-.88.484 0 .88.397.88.88 0 .484-.396.88-.88.88M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977" transform="translate(.5)"/>
													<path stroke="#F47810" stroke-width=".5" d="M4.636 19H4.42c-.39 0-.708 2.977-.708 2.977 0 .39.319.708.708.708h.217c.39 0 .709-.318.709-.708 0 0-.319-2.977-.709-2.977z" transform="translate(.5)"/>
													<path fill="#F47810" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736" transform="translate(.5)"/>
													<path stroke="#F47810" stroke-width=".5" d="M5.264 19.177c0 .407-.33.737-.736.737-.407 0-.737-.33-.737-.737s.33-.736.737-.736.736.33.736.736z" transform="translate(.5)"/>
												</g>
											</g>
										</g>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		`
		return {
			capRatingFull,
			capRatingHalf,
			capRatingEmpty
		}
	},
	computed: {
		parsedScore(){
			return parseFloat(this.score)
		}
	}
}
</script>
